export default function selectJiraSearchIssiesAreLoading(state, { source }) {
  return state.integrations.thirdPartyData[source].searchedIssues.loading
}
